import OwnerList from "./OwnerList";

export default OwnerList;